import { Text, types, useAdminContext } from "react-bricks/frontend"

import React from "react"
import { TypographyElement } from "../Typography"

export interface HealthClaimProps {
    id: string
    index: number
    text?: TypographyElement[]
}

const HealthClaim: types.Brick<HealthClaimProps> = ({ index, text, id }) => {
    const { isAdmin } = useAdminContext()

    return (
        <li key={index} className="grid grid-cols-[auto_1fr]">
            <span className="text-xs md:text-sm">{id})&nbsp;</span>
            {isAdmin ? (
                <Text
                    propName="text"
                    renderBlock={({ children }) => <p className="text-sm md:text-base">{children}</p>}
                    placeholder="Lorem ipsum dolor sit amet"
                />
            ) : text ? (
                <p className="text-sm md:text-base">{Array.isArray(text) ? text[0].children.map(c => c.text) : text}</p>
            ) : null}
        </li>
    )
}

HealthClaim.schema = {
    name: "HealthClaim",
    label: "Health Claim",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "id",
            label: "ID",
            type: types.SideEditPropType.Text,
        },
    ],
}

export default HealthClaim
